import React from 'react';
import './Health.css';
import { useParams } from 'react-router-dom';
import backgroundImage from '../Assets/health.jpeg'; // Import the background image

const Health = () => {
    const { industry } = useParams(); // Get industry from URL (e.g., /industry/Health)

    return (
        <div 
            className="coming-soon-container" 
            style={{ backgroundImage: `url(${backgroundImage})` }}
        >
            <h1>{industry ? `${industry} Solutions` : 'Touch you Shortly'}</h1>
            <p>This solution is under development and will be available soon. Stay tuned for updates!</p>
            <a href="/" className="back-home-link">Back to Home</a>
        </div>
    );
};

export default Health;